export const HEADER_LIST = [
	'작업줄번호',
	'마켓아이디',
	'작업줄명',
	'등록날짜',
	'상태',
	'삭제',
];
